<template>
  <a class="clear-stroage" :class="{ visible: showSrocllToTop }" @click.prevent="clear()">
    <i class="fa fa-close" aria-hidden="true"></i>
  </a>
</template>
<script>

  export default {
    name: 'ScrollToTop',
    data() {
      return {
        showSrocllToTop: false,
      };
    },
    mounted() {
      window.addEventListener('scroll', () => {
        this.showSrocllToTop = window.pageYOffset > 300;
      });
    },
    methods: {
      clear() {
        localStorage.clear();
        window.location.reload();
      },
    },
  };
</script>

<style lang="scss">
  @import "../styles/helpers/variables";
  .clear-stroage {
    display: block;
    position: fixed;
    right: 16px;
    bottom: -($btn-height * 2);
    width: $btn-height;
    height: $btn-height;
    line-height: $btn-height;
    transition: bottom 400ms cubic-bezier(.68, -.55, .265, 1.55), opacity .3s, background-color .3s, border-color .3s;
    border-radius: 50%;
    background-color: rgba($black-color, .3);
    color: $white-color !important;
    font-size: $font-size-lead;
    opacity: 0;
    z-index: 2000;
    text: {
      align: center;
      decoration: none;
    }
    cursor: pointer;
    &:hover {
      background-color: rgba($black-color, .8);
      color: $white-color;
    }
    &:focus, &:active { color: $white-color; }
    &.visible {
      bottom: 72px;
      opacity: 1;
    }
    @media (max-width: $screen-md) {
      bottom: ($btn-sm-height * 1.5) !important;
      width: $btn-sm-height;
      height: $btn-sm-height;
      line-height: ($btn-sm-height - 5);
    }
  }
</style>
